import { useState, useEffect } from 'react'

export default function EnrichmentSelector({ totalResults, onEnrich, onCancel, disabled = false }) {
  const [quantity, setQuantity] = useState(Math.min(100, totalResults))
  const [revealEmails, setRevealEmails] = useState(true)
  const [revealPhones, setRevealPhones] = useState(true)

  const creditsNeeded = quantity * 2

  useEffect(() => {
    setQuantity(Math.min(100, totalResults))
  }, [totalResults])

  const handleQuantityChange = (e) => {
    const value = parseInt(e.target.value) || 0
    setQuantity(Math.min(Math.max(value, 1), totalResults))
  }

  const setPreset = (value) => {
    setQuantity(Math.min(value, totalResults))
  }

  const handleEnrich = () => {
    onEnrich?.({
      quantity,
      requireEmail: false,
      revealEmails,
      revealPhones,
      creditsNeeded,
    })
  }

  return (
    <div className="preview-enrichment-section">
      <div className="enrichment-selector">
        <label className="enrichment-label">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M8 2L10 6L14 8L10 10L8 14L6 10L2 8L6 6L8 2Z" stroke="currentColor" strokeWidth="1.5" />
          </svg>
          Nombre de prospects à acheter
        </label>
        <div className="enrichment-input-group">
          <input type="number" className="enrichment-input" min="1" max={totalResults} value={quantity} onChange={handleQuantityChange} placeholder="100" />
          <span className="enrichment-max">/ {totalResults.toLocaleString()}</span>
        </div>
        <div className="enrichment-presets">
          <button className="preset-btn" onClick={() => setPreset(100)} type="button">
            100
          </button>
          <button className="preset-btn" onClick={() => setPreset(500)} type="button">
            500
          </button>
          <button className="preset-btn" onClick={() => setPreset(1000)} type="button">
            1000
          </button>
          <button className="preset-btn" onClick={() => setPreset(totalResults)} type="button">
            Tous
          </button>
        </div>

        <div className="enrichment-options" style={{ marginTop: 20, display: 'flex', flexDirection: 'column', gap: 16, padding: 20, background: 'rgb(var(--rgb-ink) / 0.05)', borderRadius: 8, border: '1px solid rgb(var(--rgb-ink) / 0.1)' }}>
          <p style={{ fontSize: 13, fontWeight: 600, color: 'rgb(var(--rgb-ink) / 0.88)', marginBottom: 4 }}>Options de révélation</p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', padding: 12, background: 'rgb(var(--rgb-ink) / 0.03)', borderRadius: 6, border: '1px solid rgb(var(--rgb-ink) / 0.1)', transition: 'all 0.2s' }}>
              <input type="checkbox" checked={revealEmails} onChange={(e) => setRevealEmails(e.target.checked)} style={{ width: 18, height: 18, cursor: 'pointer', marginRight: 10 }} />
              <span style={{ fontSize: 14, fontWeight: 500, color: 'rgb(var(--rgb-ink) / 0.88)' }}>Révéler les emails</span>
            </label>
            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', padding: 12, background: 'rgb(var(--rgb-ink) / 0.03)', borderRadius: 6, border: '1px solid rgb(var(--rgb-ink) / 0.1)', transition: 'all 0.2s' }}>
              <input type="checkbox" checked={revealPhones} onChange={(e) => setRevealPhones(e.target.checked)} style={{ width: 18, height: 18, cursor: 'pointer', marginRight: 10 }} />
              <span style={{ fontSize: 14, fontWeight: 500, color: 'rgb(var(--rgb-ink) / 0.88)' }}>Révéler les téléphones</span>
            </label>
          </div>
        </div>
      </div>

      <div className="enrichment-summary">
        <div className="summary-item">
          <span className="summary-label">Prospects sélectionnés</span>
          <span className="summary-value">{quantity.toLocaleString()}</span>
        </div>
        <div className="summary-item">
          <span className="summary-label">Coût en crédits</span>
          <span className="summary-value credits">{creditsNeeded.toLocaleString()}</span>
        </div>
      </div>

      <div className="preview-actions">
        <button className="btn btn-secondary" onClick={onCancel} type="button" disabled={disabled}>
          Annuler
        </button>
        <button className="btn btn-primary" onClick={handleEnrich} type="button" disabled={disabled}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M16 10L10 4L4 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10 16V4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          {disabled ? 'Enrichissement...' : 'Acheter les prospects'}
        </button>
      </div>
    </div>
  )
}
